import * as React from 'react'
import {ChangeEvent, Component, ReactElement} from 'react'
import {Box} from '@mui/material';
import {BlockSpacer, GridContainer, GridItem} from '../../../../../styledComponents/ResponsiveConvenience'
import {FlexContainer, FullWidthColumnFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {ApplyButton, ItemHeading, WideWhiteArea} from '../../common/resident/NatResidentApplicationsCommon'
import {Nullable} from '../../../../../app/TypeHelpers'
import EventEmitterExResident from '../../../../../components/shared/pageBaseComponents/EventEmitterExResident'
import NatResidentApplicationDetailFormItem from '../../common/resident/NatResidentApplicationDetailFormItem'
import {PPTextFieldForResident} from '../../../../../components/shared/forms/resident/PPTextFieldForResident'
import {RidgeData} from '../../../ridge/repository/NatGetRidge'
import PPSelectForResident from '../../../../../components/shared/forms/resident/PPSelectForResident'
import {addEmptyData, NoSelectedValue} from '../../../../../componentHelper/selectHelper'
import {OptionProps} from '../../../../../components/shared/forms/PPSelect'
import {autoKanaOnUpdate} from '../../../../common/util/Natutil'
import PPRadioGroupForResident, {
    ResidentRadioButtonProps
} from '../../../../../components/shared/forms/resident/PPRadioGroupForResident'
import {RESIDENCE_STYLE} from '../../../../../CodeMaster'
import {FontSize} from '../../../../../styledComponents/Constants'
import {NatResidentUserRegistrationInfo} from '../NatResidentUserRegistrationApplicationInterface'
import {PPPasswordFieldForResident} from '../../../../../components/shared/forms/resident/PPPasswordFieldForResident'

interface Props {
    condominiumName: string
    ridgeList: RidgeData[]
    selectedRidgeCd: Nullable<string>
    selectedRidgeName: Nullable<string>
    roomNumber: Nullable<string>
    familyName: Nullable<string>
    firstName: Nullable<string>
    familyNameKana: Nullable<string>
    firstNameKana: Nullable<string>
    residenceStyle: Nullable<string>
    mailAddress: string
    bankAccountNumberLast4Digits: Nullable<string>
    eventEmitter: EventEmitterExResident
    submitButtonLabel: string
    onClickApplyConfirmButton: (applyRequest: NatResidentUserRegistrationInfo) => Promise<void>
}

interface State {
    ridgeOption: OptionProps[]
    selectedRidgeCd: string
    selectedRidgeName: string
    showRidgeItem: boolean
    roomNumber: string
    familyName: string
    firstName: string
    familyNameKana: string
    firstNameKana: string
    residenceStyle: string
    bankAccountNumberLast4Digits: string
    applyButtonDisabled: boolean
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string

}


export default class NatNoAuthenticationKeyForm extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            ...this.ridgeInitialSetting(),
            roomNumber: this.props.roomNumber ?? '',
            familyName: this.props.familyName ?? '',
            firstName: this.props.firstName ?? '',
            familyNameKana: this.props.familyNameKana ?? '',
            firstNameKana: this.props.firstNameKana ?? '',
            residenceStyle: this.props.residenceStyle ?? '',
            bankAccountNumberLast4Digits: '',
            applyButtonDisabled: true,
            convertFamilyNameKana: '',
            preFamilyNameKana: '',
            convertFirstNameKana: '',
            preFirstNameKana: '',
        }

        this.handleChangeText = this.handleChangeText.bind(this)
        this.handleChangeRidge = this.handleChangeRidge.bind(this)
        this.handleChangeFamilyName = this.handleChangeFamilyName.bind(this)
        this.handleChangeFirstName = this.handleChangeFirstName.bind(this)
        this.handleChangeResidenceStyle = this.handleChangeResidenceStyle.bind(this)
        this.onClickApplyConfirmButton = this.onClickApplyConfirmButton.bind(this)
        this.onCompositionStartFamilyName = this.onCompositionStartFamilyName.bind(this)
        this.onCompositionUpdateFamilyName = this.onCompositionUpdateFamilyName.bind(this)
        this.onCompositionStartFirstName = this.onCompositionStartFirstName.bind(this)
        this.onCompositionUpdateFirstName = this.onCompositionUpdateFirstName.bind(this)
    }

    async componentDidMount(): Promise<void> {

    }

    ridgeInitialSetting(): {
        ridgeOption: OptionProps[],
        selectedRidgeCd: string,
        selectedRidgeName: string,
        showRidgeItem: boolean
    } {
        const ridgeOption = this.props.ridgeList.map((ridge) => {
            return {
                label: ridge.ridgeName.trim() === '' ? '棟名なし' : ridge.ridgeName,
                value: ridge.ridgeCd
            }
        })
        if (this.props.ridgeList.length === 1) {
            return {
                ridgeOption: ridgeOption,
                selectedRidgeCd: this.props.ridgeList[0].ridgeCd,
                selectedRidgeName: this.props.ridgeList[0].ridgeName,
                showRidgeItem: false
            }
        }
        return {
            ridgeOption: ridgeOption,
            selectedRidgeCd: this.props.selectedRidgeCd ?? '',
            selectedRidgeName: this.props.selectedRidgeName ?? '',
            showRidgeItem: true
        }
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeRidge(event: React.ChangeEvent<HTMLSelectElement>): void {
        let selectedRidgeCd: string = ''
        let selectedRidgeName: string = ''
        if (event.target.value !== NoSelectedValue) {
            selectedRidgeCd = event.target.value
            selectedRidgeName = this.state.ridgeOption.find(ridge => ridge.value === event.target.value)?.label ?? ''
        }

        this.setState({
            selectedRidgeCd: selectedRidgeCd,
            selectedRidgeName: selectedRidgeName
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            familyName: event.target.value,
            familyNameKana: event.target.value ? this.state.convertFamilyNameKana : ''
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            firstName: event.target.value,
            firstNameKana: event.target.value ? this.state.convertFirstNameKana : ''
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeResidenceStyle(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            residenceStyle: event.target.value
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    getResidenceStyleOptions(): ResidentRadioButtonProps[] {
        return RESIDENCE_STYLE.values().map((residenceStyle) => {
            const residenceStyleLabel =
                residenceStyle !== RESIDENCE_STYLE.APPROPRIATOR_AND_TENANT ?
                    residenceStyle.label : '占有者（賃貸でお住まい）'
            return {
                label: residenceStyleLabel,
                value: residenceStyle.value
            }
        })
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            selectedRidgeCd, roomNumber, familyName, firstName,
            familyNameKana, firstNameKana, residenceStyle, bankAccountNumberLast4Digits
        } = this.state

        let applyButtonDisabled = false

        if (!selectedRidgeCd || !roomNumber || !familyName || !firstName ||
            !familyNameKana || !firstNameKana || !residenceStyle || !bankAccountNumberLast4Digits) {
            applyButtonDisabled = true
        }
        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    async onClickApplyConfirmButton(): Promise<void> {
        const {
            selectedRidgeCd, selectedRidgeName, showRidgeItem, roomNumber, familyName, firstName,
            familyNameKana, firstNameKana, residenceStyle, bankAccountNumberLast4Digits
        } = this.state

        const applyContent: NatResidentUserRegistrationInfo = {
            selectedRidgeCd: selectedRidgeCd,
            selectedRidgeName: selectedRidgeName,
            showRidgeItem: showRidgeItem,
            roomNumber: roomNumber,
            familyName: familyName,
            firstName: firstName,
            familyNameKana: familyNameKana,
            firstNameKana: firstNameKana,
            residenceStyle: residenceStyle,
            bankAccountNumberLast4Digits: bankAccountNumberLast4Digits
        }

        await this.props.onClickApplyConfirmButton(applyContent)
    }

    onCompositionStartFamilyName(): void {
        this.setState({
            convertFamilyNameKana: '',
            preFamilyNameKana: this.state.familyNameKana,
        })
    }

    onCompositionUpdateFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana: string) => {
            this.setState({convertFamilyNameKana: this.state.preFamilyNameKana + kana})
        })
    }

    onCompositionStartFirstName(): void {
        this.setState({
            convertFirstNameKana: '',
            preFirstNameKana: this.state.firstNameKana,
        })
    }

    onCompositionUpdateFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana: string) => {
            this.setState({convertFirstNameKana: this.state.preFirstNameKana + kana})
        })
    }
    renderApplicantForm(): ReactElement {
        const {condominiumName, mailAddress} = this.props
        const {
            ridgeOption,
            selectedRidgeCd,
            roomNumber,
            familyName,
            firstName,
            familyNameKana,
            firstNameKana,
            residenceStyle,
            bankAccountNumberLast4Digits,
            showRidgeItem
        } = this.state

        return (
            <>
                <ItemHeading>
                    申請者情報
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'マンション名'}
                        component={condominiumName}
                    />
                    {showRidgeItem && <>
                        <Box height={'20px'}/>
                        <NatResidentApplicationDetailFormItem
                            title={'棟名'}
                            required
                            component={
                                <PPSelectForResident
                                    inputProps={{
                                        name: 'selectedRidgeCd',
                                        value: selectedRidgeCd ? selectedRidgeCd : NoSelectedValue,
                                    }}
                                    onChange={this.handleChangeRidge}
                                    options={addEmptyData(ridgeOption)}
                                    eventKeys={[`ridgeCd`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            }
                        />
                    </>}
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'部屋番号'}
                        required
                        component={
                            <PPTextFieldForResident
                                inputProps={{
                                    name: 'roomNumber',
                                    maxLength: 4,
                                    value: roomNumber
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['roomNumber']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'familyName',
                                        id: 'familyName',
                                        maxLength: 10,
                                        value: familyName,
                                        onInput: this.handleChangeFamilyName,
                                        onChange: this.handleChangeFamilyName,
                                        placeholder: '例：素敵'
                                    }}
                                    onChange={this.handleChangeFamilyName}
                                    onCompositionStart={this.onCompositionStartFamilyName}
                                    onCompositionUpdate={this.onCompositionUpdateFamilyName}
                                    eventKeys={['familyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'firstName',
                                        id: 'firstName',
                                        maxLength: 10,
                                        value: firstName,
                                        onInput: this.handleChangeFirstName,
                                        onChange: this.handleChangeFirstName,
                                        placeholder: '例：太郎'
                                    }}
                                    onChange={this.handleChangeFirstName}
                                    onCompositionStart={this.onCompositionStartFirstName}
                                    onCompositionUpdate={this.onCompositionUpdateFirstName}
                                    eventKeys={['firstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名カナ'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'familyNameKana',
                                        id: 'familyNameKana',
                                        maxLength: 20,
                                        value: familyNameKana,
                                        onChange: this.handleChangeText,
                                        placeholder: '例：ステキ'
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['familyNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'firstNameKana',
                                        id: 'firstNameKana',
                                        maxLength: 20,
                                        value: firstNameKana,
                                        placeholder: '例：タロウ'
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['firstNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'居住形態'}
                        required
                        component={
                            <GridContainer>
                                <GridItem over={12}>
                                    <PPRadioGroupForResident
                                        data={this.getResidenceStyleOptions()}
                                        selectValue={residenceStyle}
                                        onChange={this.handleChangeResidenceStyle}
                                        eventKeys={['residenceStyle']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </GridItem>
                            </GridContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'メールアドレス'}
                        component={mailAddress}
                    />
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'口座番号（下4桁）'}
                        required
                        component={
                            <PPPasswordFieldForResident
                                inputProps={{
                                    name: 'bankAccountNumberLast4Digits',
                                    maxLength: 4,
                                    value: bankAccountNumberLast4Digits,
                                    inputMode: 'numeric'
                                }}
                                onChange={this.handleChangeText}
                                eventKeys={['bankAccountNumberLast4Digits']}
                                eventEmitter={this.props.eventEmitter}
                                passwordToggle
                            />
                        }
                    />
                    <Box height={'10px'}/>
                    <Box fontSize={FontSize.Middle}>
                        ※管理費引き落としに使用している口座番号の下4桁を入力してください
                    </Box>
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    render(): ReactElement {
        const {submitButtonLabel} = this.props
        const {applyButtonDisabled} = this.state

        return (
            <>
                {this.renderApplicantForm()}
                <Box height={'15px'}/>
                <ApplyButton disabled={applyButtonDisabled} onClick={this.onClickApplyConfirmButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            {submitButtonLabel}
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}
